import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useMe } from '@/api/hooks/auth';
import { loginPath } from '@/api/client';
import { ErrorFallback, LoadingBlock } from '@/components';
import { NotAllowed } from './NotAllowed';

/** Renders `children` only for a signed-in user; otherwise redirects to `/login?next=…`. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <LoadingBlock label="Checking your session…" />;
  if (me.isError)
    return (
      <ErrorFallback error={me.error} title="Cannot reach HSI Label" onRetry={() => void me.refetch()} />
    );
  if (me.data === null) {
    return <Navigate to={loginPath(`${location.pathname}${location.search}${location.hash}`)} replace />;
  }
  return children;
}

/** Route element for admin-only sections. */
export function RequireAdmin() {
  const me = useMe();
  if (!me.data?.is_admin) return <NotAllowed />;
  return <Outlet />;
}
